module.exports = __webpack_public_path__ + "img/image-02.485efc32.png";